import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, forkJoin } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-all-principals',
  templateUrl: './all-principals.component.html',
  styleUrls: ['./all-principals.component.scss']
})
export class AllPrincipalsComponent implements OnInit, OnDestroy {
  Principals: any;
  fetchinData = true;
  private ngUnsubscribe = new Subject();

  constructor(private appService: AppService, private _changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.FetchPrincipals();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next(null);
    this.ngUnsubscribe.complete();
  }

  FetchPrincipals() {
    this.fetchinData = true;
    forkJoin([
      this.appService.getContents(),
    ]).pipe(takeUntil(this.ngUnsubscribe)).subscribe((response: any) => {
      const allData = response[0].data || [];
      this.Principals = allData.filter((x: any) => x.ContentCategoryName === 'All-Principals');
      this.fetchinData = false;
      this._changeDetectorRef.markForCheck();
    });
  }
}
